module.exports = __webpack_public_path__ + "img/banner-byi.5570187a.png";